import { render, staticRenderFns } from "./UserAvatarContent.vue?vue&type=template&id=4725e92d"
import script from "./UserAvatarContent.vue?vue&type=script&lang=js"
export * from "./UserAvatarContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports